// SHARED-005: Game settings store
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  bgmVolume: number;
  sfxVolume: number;
  quality: 'low' | 'medium' | 'high';
  language: 'zh' | 'en';

  setBgmVolume: (v: number) => void;
  setSfxVolume: (v: number) => void;
  setQuality: (q: 'low' | 'medium' | 'high') => void;
  setLanguage: (lang: 'zh' | 'en') => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      bgmVolume: 0,
      sfxVolume: 0.8,
      quality: 'high',
      language: 'zh',

      setBgmVolume: (v) => set({ bgmVolume: v }),
      setSfxVolume: (v) => set({ sfxVolume: v }),
      setQuality: (q) => set({ quality: q }),
      setLanguage: (lang) => set({ language: lang }),
    }),
    { name: 'svai-settings' },
  ),
);
